import Watchdog from 'gleam-shared/browser/watchdog'
import digCapture from 'gleam-shared/domain/digCapture'
import injectScript from 'gleam-shared/browser/injectScript'
import whenStateChanges from 'gleam-shared/browser/whenStateChanges'
import whenCaptureShows from 'gleam-shared/domain/whenCaptureShows'

const TIMEOUT = 10_000
const waiting = new Map()

export default function triggerCapture(key, dangerousScript, marker) {
  if (waiting.has(key)) {
    return waiting.get(key)
  }

  const promise = injectScript({ once: true, marker, dangerousScript }).then(() => {
    const href = digStylesHref()
    const styles = findStyles(href)

    if (styles) {
      return Watchdog(TIMEOUT, describe(key), whenStateChanges(styles))
    }
  }).then(() => {
    return Watchdog(TIMEOUT, describe(key), showCapture(key))
  }).finally(() => {
    waiting.delete(key)
  })

  waiting.set(key, promise)
  return promise
}

function showCapture(key) {
  const capture = digCapture(key)

  if (!capture) {
    return Promise.reject(new Error(`${key} failed to initialize!`))
  }

  const promise = whenCaptureShows(key)

  capture.show()

  return promise
}

function findStyles(href) {
  if (href) {
    return document.querySelector(`link[rel="stylesheet"][href="${href}"]`)
  }
}

function digStylesHref() {
  return window._app?.widget?.baseStylesSource
}

function describe(key) {
  return `The ${key} capture`
}
